






import { getLatestClientVersion } from 'src/lib/helper'
import { apolloProvider } from 'boot/apollo'

declare const alert
declare const localStorage
declare const window
declare const document

export default {
  name: 'App',
  apolloProvider,
  async mounted () {
    const token = localStorage.getItem('token')
    if (process.env.PROD && !!token) {
      console.debug('Checking client version...')
      const remoteVersion = await getLatestClientVersion()
      const localVersion = this.getCachedJsVersion()

      if (localVersion !== remoteVersion) {
        alert('New version available. Click OK to initiate download.')
        window.location.reload(true)
      }
    }
  },
  methods: {
    getCachedJsVersion () {
      const rx = /app.(\w*.?)js/g
      const arr = rx.exec(document.body.innerHTML)
      return arr[0]
    }
  }
}
